export default "__VITE_ASSET__46Oyco3A__"